import styled, { css } from 'styled-components';
import { colorVariables } from 'theme/variables';

export const ScrollWrap = styled.div`
  position: absolute;
  height: 100%;
  width: 3px;
  right: 3px;
  z-index: 1;
  padding: 6px 0;
  box-sizing: border-box;
  will-change: opacity;
  transition:
    right 135ms ease-in-out,
    width 135ms ease-in-out;

  &:hover {
    width: 5px;
  }

  ${(props) =>
    props.dragState &&
    css`
      width: 5px;
    `} ${(props) =>
    props.rtl &&
    css`
      right: auto;
      left: 3px;
    `};
`;

export const InnerHandle = styled.div`
  height: calc(100% - (2 * 6px));
  margin-top: 6px;
  background-color: ${colorVariables.gray_lightgray};
  cursor: pointer;
  transition:
    background-color 135ms ease-in-out,
    width 135ms ease-in-out,
    height 135ms ease-in-out;

  ${ScrollWrap}:hover & {
    background-color: ${colorVariables.white_verylightgainsboro};
  }

  ${(props) =>
    props.dragState &&
    css`
      background-color: ${colorVariables.white_verylightgainsboro};
    `} ${(props) =>
    props.type === 'settings' &&
    css`
      background-color: rgba(255, 255, 255, 0.2);

      &:hover {
        background-color: rgba(255, 255, 255, 0.4);
      }
    `};
`;

export const OuterContainer = styled.div`
  overflow: hidden;
  position: relative;
`;

export const ScrollHandle = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
`;

export const InnerContainer = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  user-select: none;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 0;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.05) 60%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
    transition: height 0.1s ease-in;
    will-change: height;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
`;

export const ScrollbarStyled = styled.div`
  width: 100%;

  ${(props) =>
    props.dragState &&
    css`
      user-select: none;
    `};
`;
